import "./src/styles/global.css"
import React from 'react';
import { PriceVisibilityProvider } from './src/context/PriceVisibilityContext';
import { persistAdAttributionParams, initializeAdAttribution, carryForwardAdAttribution } from "./src/utils/adAttribution";

export const wrapRootElement = ({ element }) => {
  return (
    <PriceVisibilityProvider>
      {element}
    </PriceVisibilityProvider>
  );
};

// Polyfill for localStorage to prevent SSR errors
if (typeof window !== 'undefined' && !window.localStorage) {
  Object.defineProperty(window, 'localStorage', {
    value: {
      getItem: (key) => {
        try {
          return window.localStorage ? window.localStorage.getItem(key) : null;
        } catch {
          return null;
        }
      },
      setItem: (key, value) => {
        try {
          if (window.localStorage) {
            window.localStorage.setItem(key, value);
          }
        } catch {}
      },
      removeItem: (key) => {
        try {
          if (window.localStorage) {
            window.localStorage.removeItem(key);
          }
        } catch {}
      }
    },
    configurable: false,
    writable: false
  });
}

export const onClientEntry = () => {
  const viewport = document.querySelector('meta[name="viewport"]')
  if (viewport) {
    viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1')
  }

  // Initialize attribution parameters
  initializeAdAttribution();
}

export const onRouteUpdate = ({ location }) => {
  // Carry forward active parameters to the new route URL
  carryForwardAdAttribution();
};

export const shouldUpdateScroll = ({
  routerProps: { location },
}) => {
  if (location.state && location.state.disableScroll) {
    return false;
  }
  return true;
};
